import { memo, useState } from "react";
import { useNavigate } from "react-router";
import { DownDropContainer } from "@tecorien/mimic";
import { MySignatureModal } from "components/MySignatureModal";
import { UserInfo } from "components/UserInfo";
import { config } from "config";
import { useKeycloak } from "keycloak";
import { links } from "links";
import { Permissions } from "permissions";

import { ReactComponent as SignatureIcon } from "./icons/edit.svg";
import { ReactComponent as LogoutIcon } from "./icons/logout.svg";
import { ReactComponent as ProfileIcon } from "./icons/profile.svg";

import styles from "./styles.module.scss";

export const ProfileBlock = memo(() => {
  const navigate = useNavigate();
  const { keycloak, roles } = useKeycloak();
  const [ mySignatureModalIsOpen, setMySignatureModalIsOpen ] = useState(false);

  const hasUserRole = roles.some(x => x === Permissions.AffiliateManager);

  return (
    <>
      <DownDropContainer
        trigger="click"
        component={
          <button className={styles.button}>
            <UserInfo />
          </button>
        }
        item={
          {
            id: "profile",
            label: "Profile",
            items: [
              {
                id: "my-profile",
                label: "My profile",
                externalPath: `${config.keycloakUrl}/realms/${config.keycloakRealm}/account/?referrer=${config.keycloakClientId}#/personal-info`,
                externalLinkProps: {
                  target: "_self",
                },
                icon: <ProfileIcon />,
              },
              ...(
                hasUserRole ? [
                  {
                    id: "my-signature",
                    label: "My signature",
                    icon: <SignatureIcon />,
                    onClick:  () => setMySignatureModalIsOpen(true),
                  },
                ] : []
              ),
              {
                id: "logout",
                label: "Logout",
                icon: <LogoutIcon />,
                onClick: async () => {
                  try {
                    await keycloak.logout();
                  } finally {
                    navigate(links.appRoot);
                  }
                },
              },
            ],
          }
        } />
      <MySignatureModal
        isOpen={mySignatureModalIsOpen}
        onRequestClose={() => setMySignatureModalIsOpen(false)}
      />
    </>
  );
});

export default ProfileBlock;